import React, { useEffect, useState, useRef } from "react";
import DynamicTable from "@atlaskit/dynamic-table";
import Pagination from "@atlaskit/pagination";
import { API } from "../../utility/Api";
import {
  TableWrapper,
  createHead,
  createCells,
} from "../../components/IssueLog/Table/Wrapper";
import FlagError from "../../components/Shared/Error/FlagError";
import FilterContainer from "../../components/IssueLog/FilterContainer/FilterContainer";
import ArrowDownIcon from "@atlaskit/icon/glyph/arrow-down";
import ExcelSpreadsheet16Icon from "@atlaskit/icon-file-type/glyph/excel-spreadsheet/16";
import Document16Icon from "@atlaskit/icon-file-type/glyph/document/16";
import Button, { ButtonGroup } from "@atlaskit/button";
import Popup from "@atlaskit/popup";
import BitbucketCloneIcon from "@atlaskit/icon/glyph/bitbucket/clone";
import {
  setUniqueIssues,
  issuesToRemove,
  errorHandler,
} from "../../helpers/helpers";
import moment from "moment";
import styles from "./IssueLog.module.css";
import { UseToast } from "../../components/context/ToastContext";
import { useNavigate } from "react-router-dom";
import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  ModalTransition,
} from "@atlaskit/modal-dialog";

const IssueLog = (props) => {
  const navigate = useNavigate();
  const [pageData, setPageData] = useState({
    filter: {
      timeframe: ["lastDay"],
      events: [],
      projects: [],
      initiators: [],
      issueTypes: [],
      sortFlag: false,
      sortOrder: "",
      sortingField: "",
    },
    pagination: { page: "1", size: "50" },
    totalCount: "",
    responseData: [],
  });
  const [tableCount, setTableCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [isLoading, setLoading] = useState(true);
  // const [isError, setError] = useState("");
  // const [isMessage, setMessage] = useState("");
  const [refreshPage, setRefreshPage] = useState(false);
  const [projectList, setProjectList] = useState([]);
  const [issueTypeList, setIssueTypeList] = useState([]);
  const [initiatorList, setInitiatorList] = useState([]);
  const [initiatorValues, setInitiatorValues] = useState("");
  const [projectValues, setProjectValues] = useState("");
  const [issueTypeValues, setIssueTypeValues] = useState("");
  const [timeframeValue, setTimeFrameValue] = useState(["lastDay"]);
  const [searchKey, setSearchKey] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [checkedIssues, setCheckedIssues] = useState([]);
  const [globalCheckState, setGlobalCheckState] = useState({
    allChecked: false,
    indeterminate: false,
    disabled: false,
  });
  const [checkedItems, setCheckedItems] = useState([]);
  const [tempCheckedItems, setTempCheckedItems] = useState([]);
  const { setMainMessage } = UseToast();
  const [sortFlags, setSortFlags] = useState({
    projectSortFlag: 0,
    keySortFlag: 0,
    issueTypeSortFlag: 0,
    // summarySortFlag: 0,
    eventTypeSortFlag: 0,
    eventDateSortFlag: 0,
    initiatorSortFlag: 0,
    // assigneeSortFlag: 0,
    // reporterSortFlag: 0,
  });

  const [eventValues, setEventValues] = useState("");
  const checkEventValue = useRef(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showDownloadConfirm, setShowDownloadConfirm] = useState(false);
  const [downloadType, setDownloadType] = useState("csv");
  const onPaginationChange = (e, page) => {
    setPageData((prevState) => ({
      ...prevState,
      pagination: {
        page: page,
        size: prevState.pagination.size,
      },
    }));
  };
  const [initiators, setInitiators] = useState([]);
  let userNameList = [];
  let accountIdList = [];
  let avatarUrlList = [];
  //Array of object to hold the {label: userName, value:accountId}
  let initiatorsArray = [];
  const sendAllAccountId = (uniqueAccId, data) => {
    //Initialise data
    const initialdata = data.map((record) => {
      return { ...record, userName: "-", avatar: "" };
    });
    setTableData(initialdata);
    setLoading(false);
    var promise = new Promise(function (resolve, reject) {
      uniqueAccId.forEach((accountId, index) => {
        var promise2 = new Promise(function (resolve, reject) {
          //eslint-disable-next-line
          AP.request(`/rest/api/3/user?accountId=${accountId}`)
            .then((response) => {
              const responsedata = JSON.parse(response.body);
              resolve({
                displayName: responsedata.displayName,
                accountId: accountId,
                avatarUrl: Object.values(responsedata.avatarUrls)[1],
              });
            })
            .catch((e) =>
              reject({
                displayName: "Not found",
                accountId: accountId,
                avatarUrl: "",
              })
            );
        });
        promise2
          .then(({ displayName, accountId, avatarUrl }) => {
            userNameList.push(displayName);
            accountIdList.push(accountId);
            avatarUrlList.push(avatarUrl);
            initiatorsArray.push({ label: displayName, value: accountId });
            if (userNameList.length === uniqueAccId.length)
              resolve({
                nameList: userNameList,
                idList: accountIdList,
                avatarList: avatarUrlList,
              });
          })
          .catch(({ displayName, accountId, avatarUrl }) => {
            userNameList.push(displayName);
            accountIdList.push(accountId);
            avatarUrlList.push(avatarUrl);
            if (userNameList.length === uniqueAccId.length)
              reject({
                nameList: userNameList,
                idList: accountIdList,
                avatarList: avatarUrlList,
              });
          });
      });
    });
    promise
      .then(({ nameList, idList, avatarList }) => {
        updateUserDetails(data, nameList, idList, avatarList);
      })
      .catch(({ nameList, idList, avatarList }) => {
        updateUserDetails(data, nameList, idList, avatarList);
      });
  };

  const updateUserDetails = (data, nameList, idList, avatarList) => {
    const newData = data.map((ele) => {
      let index = idList.indexOf(ele.initiatorAccountId);
      return { ...ele, userName: nameList[index], avatar: avatarList[index] };
    });
    setInitiators(initiatorsArray);
    setTableData(newData);
    setLoading(false);
  };

  const handleDownloadData = (type) => {
    setLoading(true);
    // eslint-disable-next-line
    AP.context.getToken(function (token) {
      downloadFile(token, type);
    });
    const downloadFile = async (token, type) => {
      // setError("");
      setMainMessage("");

      const checkedIssueIdList = checkedIssues.map((val) => val.id);
      const data = {
        fileFormat: type,
        event_list: {
          selectedEvents: checkedIssueIdList,
          totalCount: checkedIssues.length,
        },
      };
      await API.post(`api/download_events`, data, {
        responseType: type === "csv" ? "arraybuffer" : "json",
        headers: {
          Authorization: `JWT ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then(function (response) {
          setCheckedIssues([]);
          const newCheckedItems = Object.fromEntries(
            Object.keys(checkedItems).map((key) => [key, false])
          );
          const newTempCheckedItems = Object.fromEntries(
            Object.keys(tempCheckedItems).map((key) => [key, false])
          );
          setGlobalCheckState({
            ...globalCheckState,
            allChecked: false,
          });
          setCheckedItems(newCheckedItems);
          setTempCheckedItems(newTempCheckedItems);
          // let jsonString;
          const fileName =
            `Revyz_QuickRestore_` +
            moment().utc().format("MM-DD-YYYY") +
            "-" +
            moment().utc().get("hour") +
            "-" +
            moment().utc().get("minute") +
            "-" +
            moment().utc().get("second");
          if (type === "json") {
            const jsonString = `data:text/json;chatset=utf-8,${encodeURIComponent(
              JSON.stringify(response.data, null, 4)
            )}`;
            const link = document.createElement("a");
            link.href = jsonString;
            link.download = fileName + ".json";
            link.click();
            link.remove();
          } else if (type === "csv") {
            const jsonString = window.URL.createObjectURL(
              new Blob([response.data])
            );
            const link = document.createElement("a");
            link.href = jsonString;
            link.download = fileName + ".csv";
            link.click();
            link.remove();
          }
          setLoading(false);
        })
        .catch(function (error) {
          const data = errorHandler(error);
          setMainMessage({ appearance: "error", text: data.message });
          setLoading(false);
        });
    };
  };

  const handleRestoreData = () => {
    const checkedIssueIdList = checkedIssues.map((val) => val.id);
    const data = {
      filters_raw: pageData.filter,
      event_list: {
        selectedEvents: checkedIssueIdList,
      },
    };
    setLoading(true);
    // eslint-disable-next-line
    AP.context.getToken(function (token) {
      postIssues(token, data);
    });
  };

  const postIssues = async (token, data) => {
    // setError("");
    await API.post(`api/quick_restore`, data, {
      headers: {
        Authorization: `JWT ${token}`,
      },
    })
      .then(function (response) {
        setEventValues([]);
        setInitiatorValues([]);
        setProjectValues([]);
        setIssueTypeValues([]);
        setTimeFrameValue(["lastDay"]);
        setCheckedIssues([]);
        setCheckedItems([]);
        setTempCheckedItems([]);
        setGlobalCheckState({
          allChecked: false,
          indeterminate: false,
          disabled: false,
        });
        // setMessage("");
        // props.setShowComp("jobs");
        navigate("/restore/jobs");
        // setMessage({
        //   text: "Issue restore job triggered successfully",
        //   appearance: "success",
        // });
        setMainMessage({
          text: "Issue restore job(s) initiated successfully",
          appearance: "success",
        });
        setLoading(false);
      })
      .catch(function (error) {
        navigate("/restore/jobs");
        const data = errorHandler(error);
        setMainMessage({
          appearance: "error",
          text: data.message,
        });
        setLoading(false);
      });
  };

  const onChangeSearchKey = (value) => {
    setSearchKey(value);
  };

  const handleSearchKeySumbit = (data) => {
    setEventValues([]);
    setInitiatorValues([]);
    setProjectValues([]);
    setIssueTypeValues([]);
    setTimeFrameValue(["lastDay"]);
    setCheckedIssues([]);
    setCheckedItems([]);
    setTempCheckedItems([]);
    setGlobalCheckState({
      allChecked: false,
      indeterminate: false,
      disabled: false,
    });
    setSearchKey(data.searchKey);
    setSortFlags({
      projectSortFlag: 0,
      keySortFlag: 0,
      issueTypeSortFlag: 0,
      // summarySortFlag: 0,
      eventTypeSortFlag: 0,
      eventDateSortFlag: 0,
      initiatorSortFlag: 0,
      // assigneeSortFlag: 0,
      // reporterSortFlag: 0,
    });
    setPageData({
      filter: {
        timeframe: ["lastDay"],
        events: [],
        projects: [],
        issueTypes: [],
        initiators: [],
        sortFlag: false,
        sortOrder: "",
        sortingField: "",
      },
      pagination: { page: "1", size: "50" },
      totalCount: "",
      responseData: [],
    });
  };
  const onProjectChange = (e) => {
    const projectValues = e.map((val) => val.value);
    setProjectValues(projectValues);
  };

  const onIssueTypeChange = (e) => {
    const issueType = e.map((val) => val.value);
    setIssueTypeValues(issueType);
  };

  const onTimeframeChange = (e) => {
    setTimeFrameValue(e ? [e.value] : ["lastDay"]);
  };

  const onEventChange = (e) => {
    checkEventValue.current = e;
    const eventValues = e.map((val) => val.value);
    setEventValues(eventValues);
  };

  const onInitiatorChange = (e) => {
    const userValues = e.map((val) => val.value);
    setInitiatorValues(userValues);
  };
  const handleSetPage = (e) => {
    setPageData((prevState) => ({
      ...prevState,
      pagination: { page: e ? e : "1", size: prevState.pagination.size },
    }));
  };

  const handleSorting = (field, sortingOrder) => {
    setSortFlags((prevState) => ({
      projectSortFlag:
        field === "project"
          ? prevState.projectSortFlag === 0
            ? 1
            : prevState.projectSortFlag === 1
            ? 2
            : prevState.projectSortFlag === 2
            ? 1
            : 0
          : 0,
      keySortFlag:
        field === "jira_key"
          ? prevState.keySortFlag === 0
            ? 1
            : prevState.keySortFlag === 1
            ? 2
            : prevState.keySortFlag === 2
            ? 0
            : 0
          : 0,
      issueTypeSortFlag:
        field === "issue_type"
          ? prevState.issueTypeSortFlag === 0
            ? 1
            : prevState.issueTypeSortFlag === 1
            ? 2
            : prevState.issueTypeSortFlag === 2
            ? 0
            : 0
          : 0,
      // summarySortFlag:
      //   field === "summary"
      //     ? prevState.summarySortFlag === 0
      //       ? 1
      //       : prevState.summarySortFlag === 1
      //       ? 2
      //       : prevState.summarySortFlag === 2
      //       ? 1
      //       : 0
      //     : 0,
      eventTypeSortFlag:
        field === "event_type"
          ? prevState.eventTypeSortFlag === 0
            ? 1
            : prevState.eventTypeSortFlag === 1
            ? 2
            : prevState.eventTypeSortFlag === 2
            ? 1
            : 0
          : 0,
      eventDateSortFlag:
        field === "date"
          ? prevState.eventDateSortFlag === 0
            ? 1
            : prevState.eventDateSortFlag === 1
            ? 2
            : prevState.eventDateSortFlag === 2
            ? 1
            : 0
          : 0,
      initiatorSortFlag:
        field === "user"
          ? prevState.initiatorSortFlag === 0
            ? 1
            : prevState.initiatorSortFlag === 1
            ? 2
            : prevState.initiatorSortFlag === 2
            ? 1
            : 0
          : 0,
      // assigneeSortFlag:
      //   field === "assignee"
      //     ? prevState.assigneeSortFlag === 0
      //       ? 1
      //       : prevState.assigneeSortFlag === 1
      //       ? 2
      //       : prevState.assigneeSortFlag === 2
      //       ? 1
      //       : 0
      //     : 0,
      // reporterSortFlag:
      //   field === "reporter"
      //     ? prevState.reporterSortFlag === 0
      //       ? 1
      //       : prevState.reporterSortFlag === 1
      //       ? 2
      //       : prevState.reporterSortFlag === 2
      //       ? 1
      //       : 0
      //     : 0,
    }));
    setPageData((prevState) => ({
      ...prevState,
      filter: {
        timeframe: prevState.filter.timeframe,
        events: prevState.filter.events,
        projects: prevState.filter.projects,
        issueTypes: prevState.filter.issueTypes,
        initiators: prevState.filter.initiators,
        sortFlag: sortingOrder !== "" ? true : false,
        sortOrder: sortingOrder,
        sortingField: sortingOrder !== "" ? field : "",
      },
    }));
  };

  const handleFilters = () => {
    setCheckedIssues([]);
    setCheckedItems([]);
    setTempCheckedItems([]);
    setGlobalCheckState({
      allChecked: false,
      indeterminate: false,
      disabled: false,
    });
    if (searchKey) setSearchKey("");
    setPageData((prevState) => ({
      filter: {
        timeframe: timeframeValue ? timeframeValue : [],
        events: eventValues ? eventValues : [],
        projects: projectValues ? projectValues : [],
        issueTypes: issueTypeValues ? issueTypeValues : [],
        initiators: initiatorValues ? initiatorValues : [],
        sortFlag: prevState.filter.sortFlag,
        sortOrder: prevState.filter.sortOrder,
        sortingField: prevState.filter.sortingField,
      },
      pagination: { page: "1", size: "50" },
      totalCount: "",
      responseData: [],
    }));
  };

  const handleRefreshPage = (e) => {
    setCheckedIssues([]);
    setCheckedItems([]);
    setTempCheckedItems([]);
    setGlobalCheckState({
      allChecked: false,
      indeterminate: false,
      disabled: false,
    });
    setRefreshPage((prevState) => !prevState);
    setPageData((prevState) => ({
      ...prevState,
      pagination: { page: "1", size: "50" },
    }));
  };

  const handleCheckboxCheckAll = (event) => {
    let issuesTobeChecked = {};

    tableData.map((val) => {
      if (event.target.checked) {
        if (checkedIssues.length > 49) {
          return true;
        }
        issuesTobeChecked[val.id] = true;
        setUniqueIssues(checkedIssues, val, true);
      } else {
        issuesTobeChecked[val.id] = false;
        issuesToRemove(val.id, checkedIssues, true);
      }
      return issuesTobeChecked;
    });
    setCheckedItems({
      ...checkedItems,
      ...issuesTobeChecked,
    });

    setTempCheckedItems({
      ...tempCheckedItems,
      ...issuesTobeChecked,
    });
  };

  const handleCheckboxCheck = (event, id) => {
    if (event.target.checked) {
      if (checkedIssues.length > 49) {
        return;
      }
    }
    if (checkedIssues.length > 49) {
      if (!event.target.checked) {
        setGlobalCheckState({
          ...globalCheckState,
          indeterminate: true,
          disabled: true,
        });
      } else {
        setGlobalCheckState({
          ...globalCheckState,
          disabled: false,
        });
      }
    } else {
      setGlobalCheckState({
        allChecked: true,
        indeterminate: true,
        disabled: false,
      });
    }
    const newCheckedItems = {
      ...tempCheckedItems,
      [id.id]: !tempCheckedItems[id.id],
    };

    setCheckedItems({
      ...checkedItems,
      [id.id]: !tempCheckedItems[id.id],
    });
    setTempCheckedItems({
      ...newCheckedItems,
    });
    if (event.target.checked) {
      setCheckedIssues([...checkedIssues, id]);
    } else {
      issuesToRemove(id.id, checkedIssues, true);
    }
  };

  useEffect(() => {
    const perPageIssues = {};
    tableData.map((issue) => {
      if (Object.keys(tempCheckedItems).map(Number).includes(issue.id)) {
        perPageIssues[issue.id] = tempCheckedItems[issue.id];
      }
      return perPageIssues;
    });
    const areTrue =
      Object.values(perPageIssues).length > 0
        ? Object.values(perPageIssues).every(
            (issueSelected) =>
              issueSelected === true &&
              Object.values(perPageIssues).length === tableData.length
          )
        : false;
    const areFalse =
      Object.values(perPageIssues).length > 0
        ? Object.values(perPageIssues).every(
            (issueSelected) => issueSelected === false
          )
        : false;

    const checkedCount = Object.values(perPageIssues).filter(Boolean).length;
    if (areTrue) {
      setGlobalCheckState({
        indeterminate: false,
        allChecked: true,
        disabled: false,
      });
      if (checkedIssues.length > 49) {
        if (!areTrue) {
          setGlobalCheckState({
            ...globalCheckState,
            allChecked: true,
            disabled: true,
          });
        } else {
          setGlobalCheckState({
            allChecked: true,
            indeterminate: false,
            disabled: false,
          });
        }
      } else {
        setGlobalCheckState({
          indeterminate: false,
          allChecked: true,
          disabled: false,
        });
      }
    } else if (areFalse) {
      setGlobalCheckState({
        indeterminate: false,
        allChecked: false,
        disabled: false,
      });
      if (checkedIssues.length > 49) {
        if (!globalCheckState.allChecked) {
          setGlobalCheckState({
            ...globalCheckState,
            allChecked: false,
            disabled: true,
          });
        } else {
          setGlobalCheckState({
            ...globalCheckState,
            allChecked: false,
            disabled: false,
          });
        }
      } else {
        setGlobalCheckState({
          ...globalCheckState,
          allChecked: false,
          disabled: false,
        });
      }
    } else if (
      !areFalse &&
      !areTrue &&
      checkedCount > 0 &&
      checkedCount < tableData.length
    ) {
      setGlobalCheckState({
        allChecked: true,
        indeterminate: true,
        disabled: false,
      });
      if (checkedIssues.length > 49) {
        if (!areTrue) {
          setGlobalCheckState({
            allChecked: true,
            indeterminate: true,
            disabled: false,
          });
        } else {
          setGlobalCheckState({
            ...globalCheckState,
            disabled: false,
          });
        }
      } else {
        setGlobalCheckState({
          allChecked: true,
          indeterminate: true,
          disabled: false,
        });
      }
    }
  }, [tempCheckedItems, checkedIssues, tableData]);

  useEffect(() => {
    const getData = async (token) => {
      // setError("");
      setMainMessage("");
      setLoading(true);
      const queryparams = `${searchKey ? `searchKey=${searchKey}` : ""}`;
      await API.post(`api/events?${queryparams}`, pageData, {
        headers: {
          Authorization: `JWT ${token}`,
        },
      })
        .then(function (response) {
          sendAllAccountId(
            response.data.initiators,
            response.data.responseData
          );
          setTableCount(response.data.totalCount);
          const projList = response.data.projects.map((e) => {
            return { label: e, value: e };
          });
          const userList = response.data.initiators.map((e) => {
            return { label: e, value: e };
          });
          const jiraTypeList = response.data.issueTypes.map((e) => {
            return { label: e, value: e };
          });
          setProjectList(projList);
          setInitiatorList(userList);
          setIssueTypeList(jiraTypeList);
          // setSearchKey("");
          setTotalPages(
            Math.ceil(response.data.pagination.count / pageData.pagination.size)
          );
          // setLoading(false);
        })
        .catch(function (error) {
          setMainMessage({ appearance: "error", data: error.message });
          setLoading(false);
        });
    };
    if (tableData.length !== 0) {
      setLoading(true);
      setGlobalCheckState({
        indeterminate: false,
        allChecked: false,
        disabled: false,
      });
    }

    //eslint-disable-next-line
    AP.context.getToken(function (token) {
      getData(token);
    });
  }, [props.selected, pageData, props.appType, refreshPage]);

  // if (isError) {
  //   return (
  //     <div className={styles.error}>
  //       <strong>Something went wrong</strong>
  //       <FlagError setFlag={[1]} message={isError} />
  //     </div>
  //   );
  // }
  const head = createHead(
    true,
    sortFlags,
    handleCheckboxCheckAll,
    handleSorting,
    isLoading,
    globalCheckState
  );
  const rows = createCells(
    tableData,
    handleCheckboxCheck,
    tempCheckedItems,
    checkedIssues
  );

  // if (isMessage) {
  //   return (
  //     <div className={styles.error}>
  //       <FlagError setFlag={[1]} message={isMessage} />
  //     </div>
  //   );
  // }

  return (
    <div className={styles.quickrestoreissuelogcontainer}>
      <ModalTransition>
        {showConfirmation && (
          <Modal onClose={() => setShowConfirmation(false)}>
            <ModalHeader>
              <ModalTitle>Restore issue(s)</ModalTitle>
            </ModalHeader>
            <ModalBody>
              Restoring issue(s) will create new issue(s) without updating
              original one(s).
              <br /> <br />
              Are you sure you want to restore the selected issue(s) ?
            </ModalBody>
            <ModalFooter>
              <Button
                appearance="subtle"
                onClick={() => setShowConfirmation(false)}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                onClick={() => {
                  handleRestoreData();
                  setShowConfirmation(false);
                }}
                appearance="primary"
                autoFocus
              >
                Restore
              </Button>
            </ModalFooter>
          </Modal>
        )}

        {showDownloadConfirm && (
          <Modal onClose={() => setShowDownloadConfirm(false)}>
            <ModalHeader>
              <ModalTitle>Download issue(s) </ModalTitle>
            </ModalHeader>
            <ModalBody>
              This action will download a {downloadType} file containing
              selected issue(s).
            </ModalBody>
            <ModalFooter>
              <Button
                appearance="subtle"
                onClick={() => setShowDownloadConfirm(false)}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                onClick={() => {
                  handleDownloadData(downloadType);
                  setShowDownloadConfirm(false);
                }}
                appearance="primary"
                autoFocus
              >
                Download
              </Button>
            </ModalFooter>
          </Modal>
        )}
      </ModalTransition>
      <FilterContainer
        projectList={projectList}
        initiatorList={initiatorList}
        issueTypeList={issueTypeList}
        searchKey={searchKey}
        onChangeSearchKey={onChangeSearchKey}
        handleSearchKeySumbit={handleSearchKeySumbit}
        onProjectChange={onProjectChange}
        onIssueTypeChange={onIssueTypeChange}
        onTimeframeChange={onTimeframeChange}
        onEventChange={onEventChange}
        onInitiatorChange={onInitiatorChange}
        handleFilters={handleFilters}
        handleRefreshPage={handleRefreshPage}
        tableCount={tableCount}
        isLoading={isLoading}
        checkedIssues={checkedIssues}
        projectValues={projectValues}
        issueTypeValues={issueTypeValues}
        timeframeValue={timeframeValue}
        eventValues={eventValues}
        initiatorValues={initiatorValues}
        setRefreshPage={setRefreshPage}
        initiators={initiators}
      />
      <div className={styles.tablecontainer}>
        <TableWrapper>
          <DynamicTable
            head={head}
            rows={rows}
            rowsPerPage={undefined}
            defaultPage={1}
            loadingSpinnerSize="large"
            isLoading={isLoading}
            isFixedSize
            onSetPage={handleSetPage}
            emptyView={<strong>No data found</strong>}
          />
        </TableWrapper>

        {totalPages !== 0 ? (
          <Pagination
            pages={Array.from({ length: totalPages }).map(
              (currentElement, i) => i + 1
            )}
            onChange={onPaginationChange}
            selectedIndex={pageData.pagination.page - 1}
          />
        ) : (
          ""
        )}
        <div className={styles.buttons}>
          <ButtonGroup className={styles.buttons}>
            <Popup
              isOpen={isOpen}
              onClose={() => setIsOpen(false)}
              placement="bottom-start"
              content={() => (
                <div className={styles.content}>
                  <ButtonGroup appearance="subtle">
                    <Button
                      spacing="compact"
                      iconBefore={<Document16Icon label="Download JSON" />}
                      onClick={() => {
                        setDownloadType("json");
                        setShowDownloadConfirm(true);
                        // handleDownloadData("json");
                        setIsOpen(false);
                      }}
                    >
                      JSON
                    </Button>
                    <Button
                      spacing="compact"
                      iconBefore={
                        <ExcelSpreadsheet16Icon label="Download CSV" />
                      }
                      onClick={() => {
                        setDownloadType("csv");
                        setShowDownloadConfirm(true);
                        // handleDownloadData("csv");
                        setIsOpen(false);
                      }}
                    >
                      CSV
                    </Button>
                  </ButtonGroup>
                </div>
              )}
              trigger={(triggerProps) => (
                <Button
                  {...triggerProps}
                  iconBefore={
                    <ArrowDownIcon label="Quick restore" size="medium" />
                  }
                  appearance="default"
                  isSelected={isOpen}
                  isDisabled={isLoading || checkedIssues.length === 0}
                  onClick={() => setIsOpen(!isOpen)}
                >
                  Download Data
                </Button>
              )}
            />
            <Button
              iconBefore={
                <BitbucketCloneIcon label="Restore issues" size="medium" />
              }
              appearance="primary"
              id="restoreIssues"
              onClick={() => setShowConfirmation(true)}
              isDisabled={
                isLoading ||
                checkedIssues.length === 0 ||
                checkedIssues.length > 50
              }
            >
              Quick Restore
            </Button>
          </ButtonGroup>
        </div>
      </div>
    </div>
  );
};

export default IssueLog;
